export const pcam = [
  {
    "titulo_item_nombre": "",
    "archivos": [
      {
        "extencion":"archivo-pdf",
        "file_item_nombre": "Convenio específico de colaboración",
        "file_item_url": "../../../contenido/transparencia/convenios/PROCAM/DGCES-CCTR-HGO-PROCAM-01-18.pdf"
      },
      {
        "extencion":"archivo-pdf",
        "file_item_nombre": "Informe de Avance Financiero PROCAM",
        "file_item_url": "../../../contenido/transparencia/convenios/PROCAM/Informe de Avance Financiero PROCAM.pdf"
      },
      {
        "extencion":"archivo-pdf",
        "file_item_nombre": "Proyecto PROCAM Tulancingo",
        "file_item_url": "../../../contenido/transparencia/convenios/PROCAM/Proyecto PROCAM Tulancingo.pdf"
      },
      {
        "extencion":"archivo-pdf",
        "file_item_nombre": "1. Primer Informe Tecnico PROCAM",
        "file_item_url": "../../../contenido/transparencia/convenios/PROCAM/1. Primer Informe Tecnico PROCAM.pdf"
      },
      {
        "extencion":"archivo-pdf",
        "file_item_nombre": "2. Segundo Informe Tecnico PROCAM",
        "file_item_url": "../../../contenido/transparencia/convenios/PROCAM/2. Segundo Informe Tecnico PROCAM.pdf"
      },
      {
        "extencion":"archivo-pdf",
        "file_item_nombre": "3. Tercer Informe Tecnico PROCAM",
        "file_item_url": "../../../contenido/transparencia/convenios/PROCAM/3. Tercer Informe Tecnico PROCAM.pdf"
      },
      {
        "extencion":"archivo-pdf",
        "file_item_nombre": "4. Cuarto Informe Tecnico PROCAM",
        "file_item_url": "../../../contenido/transparencia/convenios/PROCAM/4. Cuarto Informe Tecnico PROCAM.pdf"
      }
    ]
  }
  
  
]